// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__chUJX","hidden":"styles_hidden__6sj49","wrapper":"styles_wrapper__ri_NG","btn__cross":"styles_btn__cross__5w86x"};